import { styled } from "@acko-tech/building-blocks.ui.common";

export const Wrapper = styled.div`
  position: sticky;
  bottom: 0px;
  left: 0px;
  box-sizing: border-box;
  background: white;

  ::before {
    position: absolute;
    content: "";
    left: 0px;
    right: 0px;
    height: 6px;
    width: 100%;
    box-shadow: 0px -2px 4px rgba(32, 35, 44, 0.05);
  }

  /* @media (min-width: 768px) {
    position: static;

    ::before {
      position: static;
      content: "";
      box-shadow: none;
    }
  } */
`;

export const Container = styled.div`
  padding: 1rem 0px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 1.5rem;

  ${(props) => props.styles}

  @media (min-width: 768px) {
    /* padding: 0px;
    box-shadow: none;
    margin-top: 2rem; */
    ${(props) => props.dStyles}
  }
`;
